import React from 'react';
import AchatHeader from './achatHeader';
import AchatsTable from './achatsTable';
const Achats = () => {
  return (
    <>
      <AchatHeader />
      <AchatsTable />
    </>
  );
};

export default Achats;
